import type { Schemas } from '@argzombie/api-client';

/*
 * The Stories & Tech Step 4 content types (story issues #131, ADR 0042), from the generated client: shared-cs Content/StoryDefs.cs.
 * `arcs[]`, `storyRules` (StoryIssueRulesDef, named apart from the engine's `story` section) and `missions[].story`.
 */

export type ArcDef = Schemas['ArcDef'];
export type ArcLogoDef = Schemas['ArcLogoDef'];
export type ArcUnlockDef = Schemas['ArcUnlockDef'];
export type StoryTeaserDef = Schemas['StoryTeaserDef'];
export type CastDef = Schemas['CastDef'];
export type EndingDef = Schemas['EndingDef'];
/** `rewards` carries ADR 0062's `onLocation` (see `StoryRewardsDef`). */
export type IssueStoryDef = Omit<Schemas['IssueStoryDef'], 'rewards'> & {
  rewards?: StoryRewardsDef;
  /** Day Zero (ADR 0074): the player's own survivor is the hero (typed here until the client is regenerated). */
  heroIsPlayer?: boolean;
};
/** Day Zero adds `protectedUntil` (a chain id). */
export type IssueCastDef = Schemas['IssueCastDef'] & { protectedUntil?: string | null };
export type StoryLoadoutDef = Schemas['StoryLoadoutDef'];
export type CoverSpec = Schemas['CoverSpec'];
export type CoverVariantDef = Schemas['CoverVariantDef'];
export type StoryBeatVariantDef = Schemas['StoryBeatVariantDef'];
export type StoryCheckpointDef = Schemas['StoryCheckpointDef'];
/** ADR 0062 adds `onLocation` (typed here until `@argzombie/api-client` is regenerated). */
export type StoryRewardsDef = Schemas['StoryRewardsDef'] & {
  onLocation?: Schemas['ItemStack'][] | null;
  /** Day Zero's kit table (lib/validate/tutorial.ts `KitRowDef`). */
  kit?: import('../validate/tutorial').KitRowDef[] | null;
};
export type LocationRuleDef = Schemas['LocationRuleDef'];
/** ADR 0062 adds `playAnywhere` (typed here until `@argzombie/api-client` is regenerated). */
export type StoryIssueRulesDef = Schemas['StoryIssueRulesDef'] & { playAnywhere?: boolean };

/** shared-cs `StoryArcKinds.All`. */
export const STORY_ARC_KINDS = ['main', 'oneoff', 'tutorial'] as const;
/** shared-cs `StoryLocationKinds.All`. */
export const STORY_LOCATION_KINDS = ['place', 'sameAs', 'picked', 'anywhere'] as const;
/** shared-cs `StoryCoverStates.All`: the shelf's states (app, homebase, /comics). */
export const STORY_COVER_STATES = [
  'unread',
  'read',
  'in_progress',
  'locked',
  'dev_unlocked',
  'coming_soon',
] as const;
/** shared-cs `StoryOnFail.All` (a scenario lose rule's `onFail`, read only in story issues). */
export const STORY_ON_FAIL = ['', 'rewind', 'branch'] as const;
/** `LocationRuleDef.PickNear`. */
export const STORY_PICK_NEAR = ['home', 'player'] as const;
